import React, { useState, useEffect } from 'react';
import '../../../css/subscriptionFees/SubscriptionFees.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import Sidenav from '../../shared/Sidenav';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import DeleteModal from '../../shared/DeleteRoleModal';
import SuccessModal from '../../shared/SuccessModal';
import AlertModal from '../../shared/AlertModal';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { ADDSUBSCRIPTION_ENDPOINT, ALLSUBSCRIPTIONS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function SubscriptionFees() {
   const [monthlyActiveDiv, setMonthlyActiveDiv] = useState(true);
   const [monthlyExpiredDiv, setMonthlyExpiredDiv] = useState(false);
   const [yearlyActiveDiv, setYearlyActiveDiv] = useState(true);
   const [yearlyExpiredDiv, setYearlyExpiredDiv] = useState(false);
   const [newRowMonth, setNewRowMonth] = useState(false);
   const [newRowYear, setNewRowYear] = useState(false);
   const [showMonthlyEffectiveCalendar, setShowMonthlyEffectiveCalendar] = useState(false);
   const [showMonthlyExpiryCalendar, setShowMonthlyExpiryCalendar] = useState(false);
   const [showYearlyEffectiveCalendar, setShowYearlyEffectiveCalendar] = useState(false);
   const [showYearlyExpiryCalendar, setShowYearlyExpiryCalendar] = useState(false);
   const [monthEffectiveValue, setMonthEffectiveValue] = useState(new Date());
   const [monthExpiryValue, setMonthExpiryValue] = useState(new Date());
   const [yearEffectiveValue, setYearEffectiveValue] = useState(new Date());
   const [yearExpiryValue, setYearExpiryValue] = useState(new Date());
   const [monthlyDefaultValue, setMonthlyDefaultValue] = useState("");
   const [yearlyDefaultValue, setYearlyDefaultValue] = useState("");
   const [monthlyTolAmt, setMonthlyTolAmt] = useState('');
   const [yearlyTolAmt, setYearlyTolAmt] = useState('');
   const [subscriptionData, setSubscriptionData] = useState([]);
   const [confirmedHasOpen, setConfirmedHasOpen] = useState(false);
   const [monthlyEffectiveDateCalendarRender, setMonthlyEffectiveDateCalendarRender] = useState(false);
   const [monthlyExpiryDateCalendarRender, setMonthlyExpiryDateCalendarRender] = useState(false);
   const [yearlyEffectiveDateCalendarRender, setYearlyEffectiveDateCalendarRender] = useState(false);
   const [yearlyExpiryDateCalendarRender, setYearlyExpiryDateCalendarRender] = useState(false);
   const [monthlyDeleteIndex, setMonthlyDeleteIndex] = useState("");
   const [hasOpenDelete, setHasOpenDelete] = useState(false);
   const [isMonthlyEdit, setIsMonthlyEdit] = useState([]);
   const [monthlyEditIndex, setMonthlyEditIndex] = useState('');
   const [showMonthlyEffectiveCalendarEdit, setShowMonthlyEffectiveCalendarEdit] = useState([]);
   const [showMonthlyExpiryCalendarEdit, setShowMonthlyExpiryCalendarEdit] = useState([]);
   const [isYearlyEdit, setIsYearlyEdit] = useState([]);
   const [yearlyEditIndex, setYearlyEditIndex] = useState('');
   const [showYearlyEffectiveCalendarEdit, setShowYearlyEffectiveCalendarEdit] = useState([]);
   const [showYearlyExpiryCalendarEdit, setShowYearlyExpiryCalendarEdit] = useState([]);
   const [hasOpenAlert, setHasOpenAlert] = useState(false);
   const [isEditMonthlyDefaultValue, setIsEditMonthlyDefaultValue] = useState(false);
   const [isEditYearlyDefaultValue, setIsEditYearlyDefaultValue] = useState(false);
   let [monthlyIndex, setMonthlyIndex] = useState([]);
   let [yearlyIndex, setYearlyIndex] = useState([]);
   const container = React.createRef();
   var selectedTiles = [];
   let viewOnly = false;
   let roleData = useSelector(state => state.adminRoleReducer.roleData)
   const roleDataLength = roleData.length;
   for (let z = 0; z < roleDataLength; z++) {
      var rd = roleData[z].permissions;
      selectedTiles.push(rd)
   }
   selectedTiles.map(x =>
      x.map(md => {
         if (md.functionId === 19) {
            if (md.method.includes("View & Edit")) {
             viewOnly = true
            }
         }
         return true
      }))
   useEffect(() => {
      ApiCall(
         'GET',
         baseURL + ALLSUBSCRIPTIONS_ENDPOINT,
         {},
         {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         },
      ).then((apiData) => {
         console.log(apiData)
         if (apiData.flag !== -1) {
            if (apiData.flag === 500) {
               toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
            else {
               console.log('I am 200!');
               setSubscriptionData(apiData);
               console.log(apiData)
            }
         } else {
            console.log(apiData)
            //   toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
         }
      });
      ApiCall(
         'GET',
         baseURL + ALLSUBSCRIPTIONS_ENDPOINT + `?type=Default`,
         {},
         {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         },
      ).then((apiData) => {
         console.log(apiData)
         if (apiData.flag !== -1) {
            if (apiData.flag === 500) {
               toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
            }
            else {
               console.log('I am 200!');
               console.log(apiData, apiData.map(x => x.totalAmount))
               apiData.map(amt => {
                  if (amt.tenure === "Monthly Default") {
                     setMonthlyDefaultValue(amt.totalAmount)
                  }
                  else {
                     setYearlyDefaultValue(amt.totalAmount)
                  }
                  return true;
               })
            }
         } else {
            console.log(apiData)
            //   toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
         }
      });
   }, [])
   const handleClickOutside = event => {
      if (container.current && !container.current.contains(event.target)) {
         setShowMonthlyEffectiveCalendar(false);
         setShowYearlyEffectiveCalendar(false);
         setShowYearlyExpiryCalendar(false);
         setShowMonthlyExpiryCalendar(false);
         showMonthlyEffectiveCalendarEdit[monthlyEditIndex] = false;
         setShowMonthlyEffectiveCalendarEdit(showMonthlyEffectiveCalendarEdit);
         showMonthlyExpiryCalendarEdit[monthlyEditIndex] = false;
         setShowMonthlyExpiryCalendarEdit(showMonthlyExpiryCalendarEdit);
         showYearlyEffectiveCalendarEdit[yearlyEditIndex] = false;
         setShowYearlyEffectiveCalendarEdit(showYearlyEffectiveCalendarEdit);
         showYearlyExpiryCalendarEdit[yearlyEditIndex] = false;
         setShowYearlyExpiryCalendarEdit(showYearlyExpiryCalendarEdit);
      }
   };
   document.addEventListener("mousedown", handleClickOutside);
   const onCloseConfirmed = () => {
      setConfirmedHasOpen(false);
      window.location.reload();
   }
   const validateMonthlyFormFields = () => {
      let validEdit = [];
      monthlyIndex = monthlyIndex.filter((element, i) => i === monthlyIndex.indexOf(element))
      for (let index = 0; index < monthlyIndex.length; index++) {
         const element = monthlyIndex[index];
         validEdit = validEdit.concat(subscriptionData[element].totalAmount !== '')
      }
      return (monthlyEffectiveDateCalendarRender === true &&
         monthlyExpiryDateCalendarRender === true &&
         monthlyTolAmt.length > 0) || (!validEdit.includes(false) && isMonthlyEdit.includes(true)) || (isEditMonthlyDefaultValue && monthlyDefaultValue.length > 0)
   }
   const validateYearlyFormFields = () => {
      let validEdit = [];
      yearlyIndex = yearlyIndex.filter((element, i) => i === yearlyIndex.indexOf(element))
      for (let index = 0; index < yearlyIndex.length; index++) {
         const element = yearlyIndex[index];
         validEdit = validEdit.concat(subscriptionData[element].totalAmount !== '')
      }
      return (yearlyEffectiveDateCalendarRender === true &&
         yearlyExpiryDateCalendarRender === true &&
         yearlyTolAmt !== '') || (!validEdit.includes(false) && isYearlyEdit.includes(true)) || (yearlyDefaultValue.length > 0 && isEditYearlyDefaultValue)
   }
   const addMonthlySubscription = () => {
      let fromTimeStamp = monthEffectiveValue;
      let toTimeStamp = monthExpiryValue;
      fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
      toTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(toTimeStamp).toString().substring(0, 10));
      let defaultFromTimeStamp = new Date()
      defaultFromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(defaultFromTimeStamp).toString().substring(0, 10));
      if (isMonthlyEdit.length > 0) {
         if (handleMonthlyEditValidation()) {
            ApiCall(
               'PUT',
               baseURL + ADDSUBSCRIPTION_ENDPOINT,
               subscriptionData[monthlyEditIndex],
               {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-cc-trace-id': '1234',
               }
            ).then(data => {
               if (data.flag !== -1) {
                  if (data.flag === 500) {
                     if (data.data.message === message.alert.dateIntervalVerifed) {
                        // toast(message.alert.dateIntervalVerifed,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                     } else {
                        setHasOpenAlert(true);
                     }
                  }
                  else {
                     console.log('I am 200!');
                     setConfirmedHasOpen(true);
                  }
               }
               else {
                  // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
               }
            })
         }
      }
      else if (isEditMonthlyDefaultValue) {
         ApiCall(
            'POST',
            baseURL + ADDSUBSCRIPTION_ENDPOINT,
            {
               "activeFlag": true,
               "amount": 0,
               "fromDate": defaultFromTimeStamp,
               "planId": 0,
               "recommendFlag": true,
               "tax": 0,
               "tenure": "Monthly Default",
               "toDate": "10/10/2100",
               "totalAmount": monthlyDefaultValue
            },
            {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'x-cc-trace-id': '1234',

            }
         ).then(data => {
            if (data.flag !== -1) {
               if (data.flag === 500) {
                  if (data.data.message === message.alert.dateIntervalVerifed) {
                     toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                  } else {
                     setHasOpenAlert(true);
                  }
               }
               else {
                  console.log('I am 200!');
                  setConfirmedHasOpen(true);
               }
            }
            else {
               // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
         })
      }
      else {
         if (handleMonthlyValidation()) {
            console.log(
               monthlyDefaultValue, "dd"
            )
            ApiCall(
               'POST',
               baseURL + ADDSUBSCRIPTION_ENDPOINT,
               {
                  "activeFlag": true,
                  "amount": 0,
                  "fromDate": fromTimeStamp,
                  "planId": 0,
                  "tax": 0,
                  "tenure": "Monthly",
                  "toDate": toTimeStamp,
                  "totalAmount": monthlyTolAmt,
                  "recommendFlag": false
               },
               {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-cc-trace-id': '1234',

               }
            ).then(data => {
               if (data.flag !== -1) {
                  if (data.flag === 500) {
                     if (data.data.message === message.alert.dateIntervalVerifed) {
                        // toast(message.alert.dateIntervalVerifed,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                     } else {
                        setHasOpenAlert(true);
                     }
                  }
                  else {
                     console.log('I am 200!');
                     setConfirmedHasOpen(true);
                  }
               }
               else {
                  // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
               }
            })
         }
      }
   }
   const handleYearlyValidation = () => {
      let formIsValid = true;
      if (yearEffectiveValue > yearExpiryValue) {
         formIsValid = false;
         toast(message.validation.date + "!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
      }
      if (yearEffectiveValue.getTime() === yearExpiryValue.getTime()) {
         formIsValid = false;
         toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
      }
      return formIsValid;
   }
   const handleMonthlyValidation = () => {
      let formIsValid = true;
      if (monthEffectiveValue > monthExpiryValue) {
         formIsValid = false;
         toast(message.validation.date + "!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
      }
      if (monthEffectiveValue.getTime() === monthExpiryValue.getTime()) {
         formIsValid = false;
         toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
      }
      return formIsValid;
   }
   const handleYearlyEditValidation = () => {
      let formIsValid = true;
      yearlyIndex = yearlyIndex.filter((element, i) => i === yearlyIndex.indexOf(element))
      for (let index = 0; index < yearlyIndex.length; index++) {
         const element = yearlyIndex[index];
         let fromDateParts = subscriptionData[element].fromDate.split("/");
         let toDateParts = subscriptionData[element].toDate.split("/");
         let fromDate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).getTime()
         let toDate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]).getTime()
         if (fromDate > toDate) {
            formIsValid = false;
            toast(message.validation.date + "!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
         }
         if (fromDate === toDate) {
            formIsValid = false;
            toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
         }
      }
      return formIsValid;
   }

   const handleMonthlyEditValidation = () => {
      let formIsValid = true;
      monthlyIndex = monthlyIndex.filter((element, i) => i === monthlyIndex.indexOf(element))
      for (let index = 0; index < monthlyIndex.length; index++) {
         const element = monthlyIndex[index];
         let fromDateParts = subscriptionData[element].fromDate.split("/");
         let toDateParts = subscriptionData[element].toDate.split("/");
         let fromDate = new Date(fromDateParts[2], fromDateParts[1] - 1, fromDateParts[0]).getTime()
         let toDate = new Date(toDateParts[2], toDateParts[1] - 1, toDateParts[0]).getTime()
         if (fromDate > toDate) {
            formIsValid = false;
            toast(message.validation.date + "!", { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
         }
         if (fromDate === toDate) {
            formIsValid = false;
            toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
         }
      }
      return formIsValid;
   }
   const onCloseAlert = () => {
      setHasOpenAlert(false);
   }
   const handleMonthlyDefaultValue = () => {
      setIsEditMonthlyDefaultValue(!isEditMonthlyDefaultValue)
      console.log(isEditMonthlyDefaultValue)
      if (isEditMonthlyDefaultValue === true) {
         document.getElementById('monthlyDefaultInput').readOnly = true;
      }
      else {
         document.getElementById('monthlyDefaultInput').readOnly = false;
      }
   }
   const handleYearlyDefaultValue = () => {
      setIsEditYearlyDefaultValue(!isEditYearlyDefaultValue);
      if (isEditYearlyDefaultValue === true) {
         document.getElementById('yearlyDefaultInput').readOnly = true;
      }
      else {
         document.getElementById('yearlyDefaultInput').readOnly = false;
      }
   }
   const changeMonthlyDefaultValue = (e) => {
      let value = e.target.value;
      value = value.replace(/[^0-9\.]/gi, "");
      setMonthlyDefaultValue(value)
   }
   const changeYearlyDefaultValue = (e) => {
      let value = e.target.value;
      value = value.replace(/[^0-9\.]/gi, "");
      setYearlyDefaultValue(value)
   }
   const addYearlySubscription = () => {
      let fromTimeStamp = yearEffectiveValue;
      let toTimeStamp = yearExpiryValue;
      fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(fromTimeStamp).toString().substring(0, 10));
      toTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(toTimeStamp).toString().substring(0, 10));
      let defaultFromTimeStamp = new Date()
      defaultFromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(defaultFromTimeStamp).toString().substring(0, 10));
      if (isYearlyEdit.length > 0) {
         if (handleYearlyEditValidation()) {
            ApiCall(
               'PUT',
               baseURL + ADDSUBSCRIPTION_ENDPOINT,
               subscriptionData[yearlyEditIndex],
               {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-cc-trace-id': '1234',
               }
            ).then(data => {
               if (data.flag !== -1) {
                  if (data.flag === 500) {
                     if (data.data.message === message.alert.dateIntervalVerifed) {
                        // toast(message.alert.dateIntervalVerifed,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
                     } else {
                        setHasOpenAlert(true);
                     }
                  }
                  else {
                     console.log('I am 200!');
                     setConfirmedHasOpen(true);
                  }
               }
               else {
                  toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
               }
            })
         }
      }
      else if (isEditYearlyDefaultValue) {
         ApiCall(
            'POST',
            baseURL + ADDSUBSCRIPTION_ENDPOINT,
            {
               "activeFlag": true,
               "amount": 0,
               "fromDate": defaultFromTimeStamp,
               "planId": 0,
               "recommendFlag": true,
               "tax": 0,
               "tenure": "Yearly Default",
               "toDate": "10/10/2100",
               "totalAmount": yearlyDefaultValue
            },
            {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'x-cc-trace-id': '1234',
            }
         ).then(data => {
            if (data.flag !== -1) {
               if (data.flag === 500) {
                  if (data.data.message === message.alert.dateIntervalVerifed) {
                     toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                  } else {
                     setHasOpenAlert(true);
                  }
               }
               else {
                  console.log('I am 200!');
                  setConfirmedHasOpen(true);
               }
            }
            else {
               // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
         })
      }
      else {
         if (handleYearlyValidation()) {
            ApiCall(
               'POST',
               baseURL + ADDSUBSCRIPTION_ENDPOINT,
               {
                  "activeFlag": true,
                  "amount": 0,
                  "fromDate": fromTimeStamp,
                  "planId": 0,
                  "tax": 0,
                  "tenure": "Yearly",
                  "toDate": toTimeStamp,
                  "totalAmount": yearlyTolAmt,
                  "recommendFlag": false
               },
               {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'x-cc-trace-id': '1234',
               }
            ).then(data => {
               if (data.flag !== -1) {
                  if (data.flag === 500) {
                     if (data.data.message === message.alert.dateIntervalVerifed) {
                        toast(message.alert.dateIntervalVerifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                     } else {
                        setHasOpenAlert(true);
                     }
                  }
                  else {
                     console.log('I am 200!');
                     setConfirmedHasOpen(true);
                  }
               }
               else {
                  // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
               }
            })
         }
      }
   }

   const getDate = (dateString) => {
      //   split the date in order to get day, month and year separately and then use it in another constructor - Date(year, month, day)
      let dateParts = dateString.split("/");
      // month is 0-based, that's why we need dataParts[1] - 1
      let date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]).toString();
      let day = date.split(' ')[2];
      let month = date.split(' ')[1];
      let year = date.split(' ')[3];
      return `${day}-${month}-${year}`;
   }
   const showMonthlyActiveScreen = () => {
      setMonthlyActiveDiv(true);
      setMonthlyExpiredDiv(false);
      document.getElementById('monthlyActiveTab').style.borderBottom = "2px solid #857A71";
      document.getElementById('monthlyExpiredTab').style.borderBottom = "none";
   }
   const showMonthlyExpiredScreen = () => {
      setMonthlyExpiredDiv(true);
      setMonthlyActiveDiv(false);
      document.getElementById('monthlyExpiredTab').style.borderBottom = "2px solid #857A71";
      document.getElementById('monthlyActiveTab').style.borderBottom = "none";
   }
   const showYearlyActiveScreen = () => {
      setYearlyActiveDiv(true);
      setYearlyExpiredDiv(false);
      document.getElementById('yearlyActiveTab').style.borderBottom = "2px solid #857A71";
      document.getElementById('yearlyExpiredTab').style.borderBottom = "none";
   }
   const showYearlyExpiredScreen = () => {
      setYearlyExpiredDiv(true);
      setYearlyActiveDiv(false);
      document.getElementById('yearlyExpiredTab').style.borderBottom = "2px solid #857A71";
      document.getElementById('yearlyActiveTab').style.borderBottom = "none";
   }
   const deleteMonthlySubscription = (deleteIndex) => {
      setMonthlyDeleteIndex(deleteIndex);
      setHasOpenDelete(true);
   }
   const confirmDelete = () => {
      ApiCall(
         'DELETE',
         baseURL + ALLSUBSCRIPTIONS_ENDPOINT + `?planId=${subscriptionData[monthlyDeleteIndex].planId}`,
         {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'x-cc-trace-id': '1234',
         },
      ).then((apiData) => {
         if (apiData.flag !== -1) {
            if (apiData.flag === 500) {
               // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
            else {
               console.log('I am 200!');
               console.log(apiData.message);
               setConfirmedHasOpen(true);
               setHasOpenDelete(false);
            }
         } else {
            // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
         }
      });
   }
   const onCloseDeleteModal = () => {
      setHasOpenDelete(false);
   }
   const addNewRoleMonth = () => {
      setNewRowMonth(true);
      document.getElementById('monthlyActiveDataOuterDiv').scrollTop = 0;
      document.documentElement.scrollTop = 0;
   }
   const addNewRoleYear = () => {
      setNewRowYear(true);
      document.getElementById('yearlyActiveDataOuterDiv').scrollTop = 0;
      document.documentElement.scrollTop = 0;
   }
   const toggleMonthlyEffectiveCalendar = () => {
      setShowMonthlyEffectiveCalendar(!showMonthlyEffectiveCalendar);
      setMonthlyEffectiveDateCalendarRender(true)
   }
   const handleMonthlyEffectiveDateChanged = (e) => {
      setMonthEffectiveValue(e);
      setShowMonthlyEffectiveCalendar(false)
   }
   const toggleMonthlyExpiryCalendar = () => {
      setShowMonthlyExpiryCalendar(!showMonthlyExpiryCalendar);
      setMonthlyExpiryDateCalendarRender(true)
   }
   const handleMonthlyExpiryDateChanged = (e) => {
      setMonthExpiryValue(e);
      setShowMonthlyExpiryCalendar(false);
   }
   const toggleYearlyEffectiveCalendar = () => {
      setShowYearlyEffectiveCalendar(!showYearlyEffectiveCalendar);
      setYearlyEffectiveDateCalendarRender(true)
   }
   const handleYearlyEffectiveDateChanged = (e) => {
      setYearEffectiveValue(e);
      setShowYearlyEffectiveCalendar(false);
   }
   const toggleYearlyExpiryCalendar = () => {
      setShowYearlyExpiryCalendar(!showYearlyExpiryCalendar);
      setYearlyExpiryDateCalendarRender(true)
   }
   const handleYearlyExpiryDateChanged = (e) => {
      setYearExpiryValue(e);
      setShowYearlyExpiryCalendar(false);
   }
   const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
   let monthlyEffectiveDateValue = monthEffectiveValue.getDate() + "-" + months[monthEffectiveValue.getMonth()] + "-" + monthEffectiveValue.getFullYear();
   if (monthEffectiveValue.getDate() <= 9) {
      monthlyEffectiveDateValue = "0" + monthlyEffectiveDateValue;
   }
   let monthlyExpiryDateValue = monthExpiryValue.getDate() + "-" + months[monthExpiryValue.getMonth()] + "-" + monthExpiryValue.getFullYear();
   if (monthExpiryValue.getDate() <= 9) {
      monthlyExpiryDateValue = "0" + monthlyExpiryDateValue;
   }
   let yearlyEffectiveDateValue = yearEffectiveValue.getDate() + "-" + months[yearEffectiveValue.getMonth()] + "-" + yearEffectiveValue.getFullYear();
   if (yearEffectiveValue.getDate() <= 9) {
      yearlyEffectiveDateValue = "0" + yearlyEffectiveDateValue;
   }
   let yearlyExpiryDateValue = yearExpiryValue.getDate() + "-" + months[yearExpiryValue.getMonth()] + "-" + yearExpiryValue.getFullYear();
   if (yearExpiryValue.getDate() <= 9) {
      yearlyExpiryDateValue = "0" + yearlyExpiryDateValue;
   }
   return (
      <div className="outer1" id="outerdiv">
         <MetaDecorator title={TitleDescription.subscriptionFeesPageTitle} description={TitleDescription.subscriptionFeesPageDescription} />
         <div className="screen">
            <div class="subscriptionFeeContainer">
               <div id="outerheader" >
               </div>
               <Sidenav />
               <div class="subscriptionFeeSection" id="createFeeSection">
                  <p class="pt-2 pb-2" id="subscriptionFeeHeadingTitle">Subscription Fees</p>
                  {/* View Only Access */}
                  <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                     <img alt="View Only Access" src={viewAccess} />
                     <span className="viewOnly">View Only Access</span>
                  </div>
                  <div>
                     <div class="subscriptionFeeCardContainer">
                        <div class="subscriptionFeeMonthlyPlanCardContainer">
                           <div class="subscriptionFeeHeaderDiv">
                              <div class="subscriptionFeeHeaderDivInner">
                                 <div class="subscriptionFeeDefaultAmtRow">
                                    <div class="subscriptionFeePlanDiv"><small class="subscriptionFeePlanText">Monthly Plan</small></div>
                                    <div class="subscriptionFeeDefaultAmtContainer">
                                       <small class="subscriptionFeeDefaultAmtText">Default Amount* <small class="subscriptionFeeRText">R</small></small>
                                       <small class="subscriptionFeeIncludingVATText">(Including VAT)</small>
                                    </div>
                                    <div class="defaultAmtEditDiv">
                                       <input readOnly class="defaultamtInputBox"
                                          value={monthlyDefaultValue}
                                          onChange={changeMonthlyDefaultValue}
                                          id="monthlyDefaultInput"
                                          type="text"
                                       />
                                       <img src={isEditMonthlyDefaultValue ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')} width="18" height="18" class="ml-2 mt-2" alt="" loading="lazy" onClick={handleMonthlyDefaultValue} style={{ display: !viewOnly ? "none" : null }} />
                                    </div>
                                 </div>
                                 <div class="subscriptionFeeActiveExpiredContainer">
                                    <div class="subscriptionFeeActiveDiv" id="monthlyActiveTab" onClick={showMonthlyActiveScreen}><small class="activeExpiredText">Active</small></div>
                                    <div class="subscriptionFeeExpiredDiv" id="monthlyExpiredTab" onClick={showMonthlyExpiredScreen}><small class="activeExpiredText">Expired</small></div>
                                 </div>
                              </div>
                           </div>
                           {monthlyActiveDiv && <div>
                              <div class="subscriptionFeeDataContainer">
                                 <div class="subscriptionFeeDataHeader">
                                    <div class="activeEffectiveDateDiv"><div class="subscriptionFeeEffectiveDate">
                                       <small class="dataHeaderText">Effective Date</small>
                                    </div></div>
                                    <div class="activeExpiryDateDiv"><div class="subscriptionFeeExpiredDate">
                                       <small class="dataHeaderText">Expiry Date</small>
                                    </div></div>
                                    <div class="activeAmtDiv"><div class="subscriptionFeeActiveAmt">
                                       <small class="dataHeaderText">Amount R (Including VAT)</small>
                                    </div></div>
                                 </div>
                                 <div className="subscriptionFeeActiveOuterDiv" id="monthlyActiveDataOuterDiv">
                                    {newRowMonth && <div class="newRowContainer">
                                       <div class="activeTabEffectiveDateDiv">
                                          <input class="subscriptionFeeCalendarInputBox" placeholder="Select Date" readOnly
                                             value={monthlyEffectiveDateCalendarRender ? monthlyEffectiveDateValue : null}></input>
                                          <div class="subscriptionFeeMonthlyCalendar">  {showMonthlyEffectiveCalendar ? <div ref={container}> <Calendar onChange={handleMonthlyEffectiveDateChanged} minDate={new Date()} /></div> : null}</div>
                                          <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy" onClick={toggleMonthlyEffectiveCalendar}
                                          />
                                       </div>
                                       <div class="activeTabExpiredDateDiv">
                                          <input class="subscriptionFeeCalendarInputBox" readOnly placeholder="Select Date" value={monthlyExpiryDateCalendarRender ? monthlyExpiryDateValue : null}></input>
                                          <div class="subscriptionFeeMonthlyCalendar">  {showMonthlyExpiryCalendar ? <div ref={container}> <Calendar onChange={handleMonthlyExpiryDateChanged} minDate={monthEffectiveValue} /></div> : null}</div>
                                          <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy" onClick={toggleMonthlyExpiryCalendar}
                                          />
                                       </div>
                                       <div class="amtDiv">
                                          <input class="subscriptionFeeAmtInputBox" value={monthlyTolAmt} onChange={e => {
                                             let value = e.target.value;
                                             value = value.replace(/[^0-9\.]/gi, "");
                                             setMonthlyTolAmt(value)
                                          }}></input>
                                       </div>
                                       <div class="subscriptionFeeEditDeleteContainer">
                                          <div class="subscriptionFeeEditDeleteDiv">
                                             <div id="subscriptionFeeEditDeleteInnerDiv" class="text-right pl-3">
                                                <div id="subscriptionFeeEditIconDiv" >
                                                   <img src={require('../../../assets/images/editenable.svg')} width="21" height="21" class="d-inline-block pr-1" alt="" loading="lazy" />
                                                </div>
                                                <div>
                                                   <img src={require('../../../assets/images/delete_enable.svg')} width="21" height="21" class="d-inline-block" alt="" loading="lazy"
                                                      onClick={() => {
                                                         setNewRowMonth(false);
                                                         setMonthlyTolAmt('');
                                                         setMonthlyEffectiveDateCalendarRender(false);
                                                         setMonthlyExpiryDateCalendarRender(false);
                                                      }}
                                                   />
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>}
                                    {(subscriptionData.map((aname, index) => {
                                       return (
                                          ((aname.tenure === 'Monthly') &&
                                             (aname.activeFlag === true)) &&
                                          <div class="subscriptionFeeActiveTabData">
                                             <div class="activeTabEffectiveDateDiv">
                                                {
                                                   isMonthlyEdit[index] ?
                                                      <>
                                                         <input class="subscriptionFeeCalendarInputBox" placeholder="Select Date" readOnly
                                                            value={getDate(aname.fromDate)}></input>
                                                         <div class="subscriptionFeeMonthlyCalendar">  {showMonthlyEffectiveCalendarEdit[index] ? <div ref={container}> <Calendar
                                                            onChange={(e) => {
                                                               let fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(e).toString().substring(0, 10));
                                                               subscriptionData[index].fromDate = fromTimeStamp;
                                                               showMonthlyEffectiveCalendarEdit[index] = false;
                                                               setShowMonthlyEffectiveCalendarEdit(showMonthlyEffectiveCalendarEdit);
                                                               setSubscriptionData(subscriptionData);
                                                            }}
                                                            minDate={new Date()} /></div> : null}</div>
                                                         <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy"
                                                            onClick={() => {
                                                               console.log("clicked")
                                                               showMonthlyEffectiveCalendarEdit[index] = true
                                                               setShowMonthlyEffectiveCalendarEdit(showMonthlyEffectiveCalendarEdit);
                                                               let x = [...monthlyIndex];
                                                               x.push(index)
                                                               setMonthlyIndex(x);
                                                               setMonthlyEditIndex(index);
                                                            }}
                                                         />
                                                      </>
                                                      :
                                                      <small class="activeTabDateText">{getDate(aname.fromDate)}</small>
                                                }
                                             </div>
                                             <div class="activeTabExpiredDateDiv">
                                                {
                                                   isMonthlyEdit[index] ?
                                                      <>
                                                         <input class="subscriptionFeeCalendarInputBox" readOnly placeholder="Select Date" value={getDate(aname.toDate)}></input>
                                                         <div class="subscriptionFeeMonthlyCalendar">  {showMonthlyExpiryCalendarEdit[index] ? <div ref={container}> <Calendar
                                                            onChange={(e) => {
                                                               let fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(e).toString().substring(0, 10));
                                                               subscriptionData[index].toDate = fromTimeStamp;
                                                               showMonthlyExpiryCalendarEdit[index] = false;
                                                               setShowMonthlyExpiryCalendarEdit(showMonthlyExpiryCalendarEdit);
                                                               setSubscriptionData(subscriptionData);
                                                            }}
                                                            minDate={
                                                               new Date() >
                                                                  new Date(aname.fromDate.split("/")[2], aname.fromDate.split("/")[1] - 1, aname.fromDate.split("/")[0]) ? new Date() : new Date(aname.fromDate.split("/")[2], aname.fromDate.split("/")[1] - 1, aname.fromDate.split("/")[0])
                                                            } /></div> : null}</div>
                                                         <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy"
                                                            onClick={() => {
                                                               showMonthlyExpiryCalendarEdit[index] = true
                                                               setShowMonthlyExpiryCalendarEdit(showMonthlyExpiryCalendarEdit);
                                                               let x = [...monthlyIndex];
                                                               x.push(index)
                                                               setMonthlyIndex(x);
                                                               setMonthlyEditIndex(index);
                                                            }}
                                                         />
                                                      </>
                                                      :
                                                      <small class="activeTabDateText">{getDate(aname.toDate)}</small>
                                                }
                                             </div>
                                             <div class="activeTabAmtDiv">
                                                {
                                                   isMonthlyEdit[index] ?
                                                      <input class="subscriptionFeeAmtInputBox" value={aname.totalAmount}
                                                         onChange={(e) => {
                                                            subscriptionData[index].totalAmount = e.target.value;
                                                            subscriptionData[index].totalAmount = subscriptionData[index].totalAmount.replace(/[^0-9\.]/gi, "");
                                                            setSubscriptionData(subscriptionData);
                                                         }}
                                                      />
                                                      :
                                                      <small class="activeTabAmtDataText">{aname.totalAmount}</small>
                                                }
                                             </div>
                                             <div class="subscriptionFeeEditDeleteContainer" style={{ display: !viewOnly ? "none" : null }}>
                                                <div class="subscriptionFeeEditDeleteDiv">
                                                   <div id="subscriptionFeeEditDeleteInnerDiv" class="text-right pl-3">
                                                      <div id="subscriptionFeeEditIconDiv" >
                                                         <img src={isMonthlyEdit[index] ? require('../../../assets/images/cross.svg') : (isMonthlyEdit.includes(true)) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')} width="21" height="21" class="d-inline-block pr-1" alt="" loading="lazy" onClick={() => {
                                                            if (!isMonthlyEdit.includes(true) || isMonthlyEdit[index]) {
                                                               isMonthlyEdit[index] = !isMonthlyEdit[index];
                                                               setIsMonthlyEdit(isMonthlyEdit);
                                                               let x = [...monthlyIndex];
                                                               x.push(index)
                                                               setMonthlyIndex(x);
                                                               setMonthlyEditIndex(index);
                                                            }
                                                         }} />
                                                      </div>
                                                      <div>
                                                         <img src={require('../../../assets/images/delete_enable.svg')} width="21" height="21" class="d-inline-block" alt="" loading="lazy" onClick={() => deleteMonthlySubscription(index)} />
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>);
                                    }))}
                                 </div>
                              </div>
                              <div class="subscriptionFeeCardFooter">
                                 <div class="subscriptionFeeCardFooterDiv">
                                    <div class="subscriptionFeeNoteDiv">
                                       <Link onClick={addNewRoleMonth} style={{ display: !viewOnly ? "none" : null }} className="subscriptionLink">
                                          <img src={newRowMonth ? require('../../../assets/images/plus_disable.svg') : require('../../../assets/images/add.svg')} width="19" height="19" class="d-inline-block" id="subscriptionFeeAddNewRowIcon" alt="" loading="lazy" />
                                          <small class="" id="addNewRowLink" style={{ color: newRowMonth ? "#B6B6B6" : "#428BCA" }}>Add New Row</small>
                                       </Link>
                                       <div class="activeTabNoteDiv">
                                          <small class="subscriptionFeeNoteText">* Default amount will be charged if no amount is mentioned under ‘Active’ tab</small>
                                       </div>
                                    </div>
                                    <div>
                                       <div class="subscriptionFeeButtonDiv" style={{ display: !viewOnly ? "none" : null }}>
                                          <button class="subscriptionFeeConfirmButton"
                                             disabled={!validateMonthlyFormFields()}
                                             onClick={addMonthlySubscription}><small class="subscriptionFeeButtonText">Confirm</small></button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>}
                           {monthlyExpiredDiv && <div>
                              <div class="subscriptionFeeDataContainer">
                                 <div class="subscriptionFeeDataHeader">
                                    <div class="expiredEffectiveDateDiv"><div class="effectiveDateHeader">
                                       <small class="dataHeaderText">Effective Date</small>
                                    </div></div>
                                    <div class="expiredExpiryDateDiv"><div class="expiryDateHeader">
                                       <small class="dataHeaderText">Expiry Date</small>
                                    </div></div>
                                    <div class="expiredAmtDiv"><div class="subscriptionFeeExpiredAmt">
                                       <small class="dataHeaderText">Amount R (Including VAT)</small>
                                    </div></div>
                                 </div>
                                 <div className="expirySubscriptions">
                                    {(subscriptionData.map((ename, index) => {
                                       return (
                                          (ename.tenure !== "Yearly" && ename.tenure !== "Yearly Default" && ename.activeFlag === false) &&
                                          <div class="expiredDataRow">
                                             <div class="expiredEffectiveDateDiv"><div class="subscriptionFeeEffectiveDate">
                                                <small class="expiredTabDataText">{getDate(ename.fromDate)}</small>
                                             </div></div>
                                             <div class="expiredExpiryDateDiv"><div class="subscriptionFeeExpiryDate">
                                                <small class="expiredTabDataText">{getDate(ename.toDate)}</small>
                                             </div></div>
                                             <div class="expiredAmtDiv"><div class="subscriptionFeeExpiredAmt">
                                                <small class="expiredTabDataText">{ename.totalAmount}</small>
                                             </div></div>
                                          </div>
                                       );
                                    }))}
                                 </div>
                              </div>
                              <div class="subscriptionFeeCardFooter">
                                 <div class="subscriptionFeeCardFooterDiv">
                                    <div class="subscriptionFeeNoteDiv">
                                       <div class="subscriptionFeeExpiredNote">
                                          <small class="subscriptionFeeNoteText">* Default amount will be charged if no amount is mentioned under ‘Active’ tab</small>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>}
                        </div>
                        <div class="subscriptionFeeYearlyPlanCardContainer">
                           <div class="subscriptionFeeHeaderDiv">
                              <div class="subscriptionFeeHeaderDivInner">
                                 <div class="subscriptionFeeDefaultAmtRow">
                                    <div class="subscriptionFeePlanDiv"><small class="subscriptionFeePlanText">Yearly Plan</small></div>
                                    <div class="subscriptionFeeDefaultAmtContainer">
                                       <small class="subscriptionFeeDefaultAmtText">Default Amount* <small class="subscriptionFeeRText">R</small></small>
                                       <small class="subscriptionFeeIncludingVATText">(Including VAT)</small>
                                    </div>
                                    <div class="defaultAmtEditDiv">
                                       <input readOnly class="defaultamtInputBox" value={yearlyDefaultValue} onChange={changeYearlyDefaultValue} id="yearlyDefaultInput" />
                                       <img src={isEditYearlyDefaultValue ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')} width="18" height="18" class="ml-2 mt-2" alt="" loading="lazy" onClick={handleYearlyDefaultValue} style={{ display: !viewOnly ? "none" : null }} />
                                    </div>
                                 </div>
                                 <div class="subscriptionFeeActiveExpiredContainer">
                                    <div class="subscriptionFeeActiveDiv" id="yearlyActiveTab" onClick={showYearlyActiveScreen}><small class="activeExpiredText">Active</small></div>
                                    <div class="subscriptionFeeExpiredDiv" id="yearlyExpiredTab" onClick={showYearlyExpiredScreen}><small class="activeExpiredText">Expired</small></div>
                                 </div>
                              </div>
                           </div>
                           {yearlyActiveDiv && <div>
                              <div class="subscriptionFeeDataContainer">
                                 <div class="subscriptionFeeDataHeader">
                                    <div class="activeEffectiveDateDiv"><div class="subscriptionFeeEffectiveDate">
                                       <small class="dataHeaderText">Effective Date</small>
                                    </div></div>
                                    <div class="activeExpiryDateDiv"><div class="subscriptionFeeExpiredDate">
                                       <small class="dataHeaderText">Expiry Date</small>
                                    </div></div>
                                    <div class="activeAmtDiv"><div class="subscriptionFeeActiveAmt">
                                       <small class="dataHeaderText">Amount R (Including VAT)</small>
                                    </div></div>
                                 </div>
                                 <div className="subscriptionFeeActiveOuterDiv" id="yearlyActiveDataOuterDiv">
                                    {newRowYear && <div class="newRowContainer">
                                       <div class="activeTabEffectiveDateDiv">
                                          <input class="subscriptionFeeCalendarInputBox" readOnly placeholder="Select Date" value={yearlyEffectiveDateCalendarRender ? yearlyEffectiveDateValue : null}></input>
                                          <div class="subscriptionFeeYearlyCalendar">  {showYearlyEffectiveCalendar ? <div ref={container}> <Calendar onChange={handleYearlyEffectiveDateChanged} minDate={new Date()} /></div> : null}</div>
                                          <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy" onClick={toggleYearlyEffectiveCalendar}
                                          />
                                       </div>
                                       <div class="activeTabExpiredDateDiv">
                                          <input class="subscriptionFeeCalendarInputBox" readOnly placeholder="Select Date" value={yearlyExpiryDateCalendarRender ? yearlyExpiryDateValue : null}></input>
                                          <div class="subscriptionFeeYearlyCalendar">  {showYearlyExpiryCalendar ? <div ref={container}> <Calendar onChange={handleYearlyExpiryDateChanged} minDate={yearEffectiveValue} /></div> : null}</div>
                                          <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy" onClick={toggleYearlyExpiryCalendar}
                                          />
                                       </div>
                                       <div class="amtDiv">
                                          <input class="subscriptionFeeAmtInputBox" value={yearlyTolAmt} onChange={e => {
                                             let value = e.target.value;
                                             value = value.replace(/[^0-9\.]/gi, "");
                                             setYearlyTolAmt(value)
                                          }}></input>
                                       </div>
                                       <div class="subscriptionFeeEditDeleteContainer">
                                          <div class="subscriptionFeeEditDeleteDiv">
                                             <div id="subscriptionFeeEditDeleteInnerDiv" class="text-right pl-3">
                                                <div id="subscriptionFeeEditIconDiv" >
                                                   <img src={require('../../../assets/images/editenable.svg')} width="21" height="21" class="d-inline-block pr-1" alt="" loading="lazy" />
                                                </div>
                                                <div>
                                                   <img src={require('../../../assets/images/delete_enable.svg')} width="21" height="21" class="d-inline-block" alt="" loading="lazy"
                                                      onClick={() => {
                                                         setNewRowYear(false);
                                                         setYearlyTolAmt('');
                                                         setYearlyEffectiveDateCalendarRender(false);
                                                         setYearlyExpiryDateCalendarRender(false);
                                                      }}
                                                   />
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>}
                                    {(subscriptionData.map((yaname, index) => {
                                       return (
                                          (yaname.tenure === 'Yearly'
                                             && yaname.activeFlag === true
                                          ) &&
                                          <div class="subscriptionFeeActiveTabData">
                                             <div class="activeTabEffectiveDateDiv">
                                                {
                                                   isYearlyEdit[index] ?
                                                      <>
                                                         <input class="subscriptionFeeCalendarInputBox" readOnly placeholder="Select Date" value={getDate(yaname.fromDate)}></input>
                                                         <div class="subscriptionFeeYearlyCalendar">  {showYearlyEffectiveCalendarEdit[index] ? <div ref={container}> <Calendar
                                                            onChange={(e) => {
                                                               let fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(e).toString().substring(0, 10));
                                                               subscriptionData[index].fromDate = fromTimeStamp;
                                                               showYearlyEffectiveCalendarEdit[index] = false;
                                                               setShowYearlyEffectiveCalendarEdit(showYearlyEffectiveCalendarEdit);
                                                               setSubscriptionData(subscriptionData);
                                                            }}
                                                            minDate={new Date()} /></div> : null}</div>
                                                         <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy"
                                                            onClick={() => {
                                                               showYearlyEffectiveCalendarEdit[index] = true
                                                               setShowYearlyEffectiveCalendarEdit(showYearlyEffectiveCalendarEdit);
                                                               setYearlyEditIndex(index);
                                                               let x = [...yearlyIndex];
                                                               x.push(index)
                                                               setYearlyIndex(x);
                                                            }}
                                                         />
                                                      </>
                                                      :
                                                      <small class="activeTabDateText">{getDate(yaname.fromDate)}</small>
                                                }
                                             </div>
                                             <div class="activeTabExpiredDateDiv">
                                                {
                                                   isYearlyEdit[index] ?
                                                      <>
                                                         <input class="subscriptionFeeCalendarInputBox" readOnly placeholder="Select Date" value={getDate(yaname.toDate)}></input>
                                                         <div class="subscriptionFeeYearlyCalendar">  {showYearlyExpiryCalendarEdit[index] ? <div ref={container}> <Calendar
                                                            onChange={(e) => {
                                                               let fromTimeStamp = (new Intl.DateTimeFormat(['ban', 'id'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(e).toString().substring(0, 10));
                                                               subscriptionData[index].toDate = fromTimeStamp;
                                                               showYearlyExpiryCalendarEdit[index] = false;
                                                               setShowYearlyExpiryCalendarEdit(showYearlyExpiryCalendarEdit);
                                                               setSubscriptionData(subscriptionData);
                                                            }}
                                                            minDate={
                                                               new Date() >
                                                                  new Date(yaname.fromDate.split("/")[2], yaname.fromDate.split("/")[1] - 1, yaname.fromDate.split("/")[0]) ? new Date() : new Date(yaname.fromDate.split("/")[2], yaname.fromDate.split("/")[1] - 1, yaname.fromDate.split("/")[0])
                                                            } /></div> : null}</div>
                                                         <img id="subscriptionFeeCalendarIcon" src={require('../../../assets/images/calendar.svg')} width="21" height="21" class="d-inline-block ml-1 " alt="" loading="lazy"
                                                            onClick={() => {
                                                               showYearlyExpiryCalendarEdit[index] = true
                                                               setShowYearlyExpiryCalendarEdit(showYearlyExpiryCalendarEdit);
                                                               setYearlyEditIndex(index);
                                                               let x = [...yearlyIndex];
                                                               x.push(index)
                                                               setYearlyIndex(x);
                                                            }}
                                                         />
                                                      </>
                                                      :
                                                      <small class="activeTabDateText">{getDate(yaname.toDate)}</small>
                                                }
                                             </div>
                                             <div class="activeTabAmtDiv">
                                                {
                                                   isYearlyEdit[index] ?
                                                      <input class="subscriptionFeeAmtInputBox" value={yaname.totalAmount}
                                                         onChange={(e) => {
                                                            subscriptionData[index].totalAmount = e.target.value;
                                                            subscriptionData[index].totalAmount = subscriptionData[index].totalAmount.replace(/[^0-9\.]/gi, "");
                                                            setSubscriptionData(subscriptionData)
                                                         }}
                                                      ></input>
                                                      :
                                                      <small class="activeTabAmtDataText">{yaname.totalAmount}</small>
                                                }
                                             </div>
                                             <div class="subscriptionFeeEditDeleteContainer" style={{ display: !viewOnly ? "none" : null }}>
                                                <div class="subscriptionFeeEditDeleteDiv">
                                                   <div id="subscriptionFeeEditDeleteInnerDiv" class="text-right pl-3">
                                                      <div id="subscriptionFeeEditIconDiv" >
                                                         <img src={isYearlyEdit[index] ? require('../../../assets/images/cross.svg') : (isMonthlyEdit.includes(true)) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')} width="21" height="21" class="d-inline-block pr-1" alt="" loading="lazy"
                                                            onClick={() => {
                                                               if (!isYearlyEdit.includes(true) || isYearlyEdit[index]) {
                                                                  isYearlyEdit[index] = !isYearlyEdit[index];
                                                                  setIsYearlyEdit(isYearlyEdit);
                                                                  setYearlyEditIndex(index);
                                                                  let x = [...yearlyIndex];
                                                                  x.push(index)
                                                                  setYearlyIndex(x);
                                                               }
                                                            }}
                                                         />
                                                      </div>
                                                      <div>
                                                         <img src={require('../../../assets/images/delete_enable.svg')} width="21" height="21" class="d-inline-block" alt="" loading="lazy" onClick={() => deleteMonthlySubscription(index)} />
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>);
                                    }))}
                                 </div>
                              </div>
                              <div class="subscriptionFeeCardFooter">
                                 <div class="subscriptionFeeCardFooterDiv">
                                    <div class="subscriptionFeeNoteDiv">
                                       <Link onClick={addNewRoleYear} style={{ display: !viewOnly ? "none" : null }} className="subscriptionLink">
                                          <img src={newRowYear ? require('../../../assets/images/plus_disable.svg') : require('../../../assets/images/add.svg')} width="19" height="19" class="d-inline-block" id="subscriptionFeeAddNewRowIcon" alt="" loading="lazy" />
                                          <small class="" id="addNewRowLink" style={{ color: newRowYear ? "#B6B6B6" : "#428BCA" }}>Add New Row</small>
                                       </Link>
                                       <div class="activeTabNoteDiv">
                                          <small class="subscriptionFeeNoteText">* Default amount will be charged if no amount is mentioned under ‘Active’ tab</small>
                                       </div>
                                    </div>
                                    <div>
                                       <div class="subscriptionFeeButtonDiv" style={{ display: !viewOnly ? "none" : null }}>
                                          <button class="subscriptionFeeConfirmButton"
                                             disabled={!validateYearlyFormFields()}
                                             onClick={addYearlySubscription}><small class="subscriptionFeeButtonText">Confirm</small></button>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>}
                           {yearlyExpiredDiv && <div>
                              <div class="subscriptionFeeDataContainer">
                                 <div class="subscriptionFeeDataHeader">
                                    <div class="expiredEffectiveDateDiv"><div class="effectiveDateHeader">
                                       <small class="dataHeaderText">Effective Date</small>
                                    </div></div>
                                    <div class="expiredExpiryDateDiv"><div class="expiryDateHeader">
                                       <small class="dataHeaderText">Expiry Date</small>
                                    </div></div>
                                    <div class="expiredAmtDiv"><div class="subscriptionFeeExpiredAmt">
                                       <small class="dataHeaderText">Amount R (Including VAT)</small>
                                    </div></div>
                                 </div>
                                 <div className="expirySubscriptions">
                                    {(subscriptionData.map((yename, index) => {
                                       return (((yename.tenure === "Yearly" || yename.tenure === "Yearly Default") && yename.activeFlag === false) && <div class="expiredDataRow">
                                          <div class="expiredEffectiveDateDiv"><div class="subscriptionFeeEffectiveDate">
                                             <small class="expiredTabDataText">{getDate(yename.fromDate)}</small>
                                          </div></div>
                                          <div class="expiredExpiryDateDiv"><div class="subscriptionFeeExpiryDate">
                                             <small class="expiredTabDataText">{getDate(yename.toDate)}</small>
                                          </div></div>
                                          <div class="expiredAmtDiv"><div class="subscriptionFeeExpiredAmt">
                                             <small class="expiredTabDataText">{yename.totalAmount}</small>
                                          </div></div>
                                       </div>);
                                    }))}
                                 </div>
                              </div>
                              <div class="subscriptionFeeCardFooter">
                                 <div class="subscriptionFeeCardFooterDiv">
                                    <div class="subscriptionFeeNoteDiv">
                                       <div class="subscriptionFeeExpiredNote">
                                          <small class="subscriptionFeeNoteText">* Default amount will be charged if no amount is mentioned under ‘Active’ tab</small>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <DeleteModal hasOpen={hasOpenDelete} onClick={onCloseDeleteModal} onYesClick={confirmDelete} >
            <p className="deletemodalText">Do you really want to delete this subscription?</p>
         </DeleteModal>
         <SuccessModal hasOpen={confirmedHasOpen} onClick={onCloseConfirmed}>
            <p className="confirmedText">Confirmed</p>
         </SuccessModal>
         <AlertModal hasOpen={hasOpenAlert} onClick={onCloseAlert}>
            <div className="dateRangeAlertSectionTextContainer">
               <p className="alertSectionUpperText">Date ranges cannot overlap.</p>
               <h6>Please enter new date range.</h6>
            </div>
         </AlertModal>
      </div>
   );
}
export default SubscriptionFees;